import { QueryResult } from "@/api/utils/types"
import { SoDataTableHeader } from "@/types/components/SoDataTable"
import { SoExportCsvButtonData } from "@/components/dataTable/SoExportCsvButton.vue"
import dayjs from "dayjs"
import { headers } from "@/views/operations/smartMeters/components/InstallCodesConfig"
import { Install_Codes } from "@/api/hasura/generated/graphql"
import { InstallCodeQueryResult } from "@/services/operations/InstallCodesService"
import { IInstallCode } from "./installCode.types"

interface IInstallCodesCSVExporter {
  getConfig: () => {
    data: SoExportCsvButtonData
    headers: SoDataTableHeader[]
    fileName: () => string
  }
}

export class InstallCodesCSVExporter implements IInstallCodesCSVExporter {
  private exportQuery: QueryResult<InstallCodeQueryResult> | null

  constructor(exportQuery: QueryResult<InstallCodeQueryResult> | null) {
    this.exportQuery = exportQuery
  }

  public getConfig() {
    return {
      data: this.parseDataForCSV(),
      headers: headers,
      fileName: this.getFilename,
    }
  }

  private parseDataForCSV(): SoExportCsvButtonData {
    if (!this.exportQuery) return { isLoading: false, items: [] }
    const modelToCSVContent = (installCode: IInstallCode) =>
      headers.reduce((acc, header) => {
        acc[header.key] = this.handleObjectMapping(installCode, header)
        return acc
      }, {})

    return {
      isLoading: this.exportQuery.isFetching,
      items: this.exportQuery.data?.records.map(modelToCSVContent) ?? [],
    }
  }

  private handleObjectMapping(
    installCode: IInstallCode,
    header: SoDataTableHeader<keyof IInstallCode, keyof Install_Codes>,
  ) {
    const value = installCode[header.key]
    if (typeof value === "object" && "text" in value) {
      return value.text
    }

    return value
  }

  private readonly getFilename = (): string => {
    return `install-codes-results-${dayjs().toISOString()}.csv`
  }
}
